import { useEffect, useState } from 'react'
import { NavLink, Outlet, useLocation } from 'react-router-dom'

import { Icon } from '@iconify/react'

import Sidebar from '../../components/Sidebar/Sidebar'
import sidebarMenu from '../../components/Sidebar/menu'

import './DashboardLayout.scss';

export default function DashboardLayout() {
  const location = useLocation()

  const [sidebarOpen, setSidebarOpen] =
    useState(false)

  /* ========================================
     AUTO CLOSE SIDEBAR ON ROUTE CHANGE
  ======================================== */

  useEffect(() => {
    setSidebarOpen(false)
  }, [location.pathname])

  /* ========================================
     PREVENT BODY SCROLL WHEN SIDEBAR OPEN
  ======================================== */

  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }

    return () => {
      document.body.style.overflow = ''
    }
  }, [sidebarOpen])

  const sidebarItems = [...sidebarMenu, { items: [{ label: 'Profile', path: '/profile', icon: 'mdi:account' }] }]

  return (
    <>
      {/* ========================================
          OVERLAY
      ======================================== */}

      <div
        className={`sidebar-overlay ${
          sidebarOpen ? 'active' : ''
        }`}
        onClick={() => setSidebarOpen(false)}
      />

      {/* ========================================
          LAYOUT
      ======================================== */}

      <div className="dashboard-layout">
        {/* ========================================
            SIDEBAR
        ======================================== */}

        <Sidebar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />

        {/* ========================================
            MAIN CONTENT
        ======================================== */}

        <div className="dashboard-main">
          {/* ========================================
              MOBILE / TABLET NAVBAR
          ======================================== */}

          <header className="mobile-navbar">
            <nav className="mobile-navbar__navigation" aria-label="Mobile navigation">
              {sidebarItems.flatMap((group) => group.items).map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.path === '/'}
                  className={({ isActive }) => [
                    'mobile-navbar__link',
                    isActive ? 'mobile-navbar__link--active' : '',
                  ].filter(Boolean).join(' ')}
                >
                  <Icon icon={item.icon} width={18} height={18} />
                  <span>{item.label}</span>
                </NavLink>
              ))}
            </nav>
          </header>

          {/* ========================================
              PAGE CONTENT
          ======================================== */}

          <main className="dashboard-content">
            <div className="dashboard-container">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </>
  )
}
